import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withPreloading } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { authInterceptor } from './app/core/interceptors/auth.interceptor';
import { apiPrefixInterceptor } from './app/core/interceptors/api-prefix.interceptor';
import { unauthorizedInterceptor } from './app/core/interceptors/unauthorized.interceptor';
import { forbiddenInterceptor } from './app/core/interceptors/forbidden.interceptor';

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([apiPrefixInterceptor, authInterceptor, unauthorizedInterceptor, forbiddenInterceptor])
    ),
  ],
}).catch((err) => console.error(err));
